import { Component, input, output } from '@angular/core';
import { HeatLayer } from 'leaflet';

@Component({
  selector: 'app-control-slider',
  imports: [],
  templateUrl: './control-slider.component.html',
  styleUrl: './control-slider.component.css',
})
export class ControlSliderComponent {
  public heatLayer = input<HeatLayer>();
  public radiusChange = output<number>();
  protected currentRadius = 7;

  protected onSliderChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.currentRadius = Number(target.value);
    this.radiusChange.emit(this.currentRadius);
  }
}
